import {ForceToolApi} from './ForceToolApi';
import * as Types from './Types';
import {ForceToolLayout, ForceToolUI} from './ForceToolUI';
import {ForceToolExternalSetupInfo} from './Types';

export function runTestApp() {
    ForceToolApi.getDefinition()
        .then(definition => displayDefinition(definition));

    const externalSetupInfo: ForceToolExternalSetupInfo = {
        isForceToolDebugEnabled: () => true,
        isForceToolEnabled: () => true,
        forceToolDemoPINHash: () => 'e10adc3949ba59abbe56e057f20f883e',
        isGameCollectable: () => false
    };
    ForceToolUI.initialize(ForceToolLayout.Debug, externalSetupInfo);
}

function displayDefinition(definition: Types.ForceToolDefinition) {
    console.log(`Categories (${definition.Categories.length}) and sets:`);

    for (let i = 0; i < definition.Categories.length; i++) {
        const category = definition.Categories[i];
        console.log(`\t${category.Name}`);
        if (category.Sets.length === 0) {
            console.log('\t' + '- NO SETS');
        } else {
            for (let j = 0; j < category.Sets.length; j++) {
                const set = category.Sets[j];
                console.log('\t' + `- ${set.Name} [${set.Description}] | ${set.File}`);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/TestApp.ts